export default __webpack_public_path__ + "static/media/ImageWaterMark.f9268278.svg";